import { useEffect, useState } from 'react';
import { navLinks, siteInfo } from '@/mocks/chigua';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* breaking ticker */}
      <div className="hidden md:block bg-primary-700 text-background-50">
        <div className="mx-auto flex h-8 max-w-7xl items-center gap-3 px-4 text-xs md:px-6">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/15 px-2.5 py-0.5 font-medium tracking-wide">
            <i className="ri-flashlight-fill text-sm"></i> 编辑室速报
          </span>
          <p className="truncate">今日新档案：〈一场"凌晨热搜"的完整时间线复盘〉已上线，速来深挖 →</p>
          <span className="ml-auto hidden whitespace-nowrap lg:inline">瓜田编辑室 · 每日更新</span>
        </div>
      </div>

      {/* main bar */}
      <div
        className={`transition-colors duration-300 ${
          scrolled ? 'bg-background-50/90 backdrop-blur-md shadow-sm' : 'bg-background-50'
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4 md:h-20 md:px-6">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex cursor-pointer items-center gap-2.5"
            aria-label={siteInfo.name}
          >
            <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50 md:h-10 md:w-10">
              瓜
            </span>
            <span className="font-heading text-xl font-black tracking-tight text-foreground-900 md:text-2xl">
              吃瓜今日
            </span>
          </button>

          <nav className="ml-auto hidden items-center gap-1 lg:flex">
            {navLinks.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={(e) => {
                  e.preventDefault();
                  go(n.href);
                }}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <a
            href="#dive"
            onClick={(e) => {
              e.preventDefault();
              go('#dive');
            }}
            className="ml-auto hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 lg:ml-3 lg:inline-flex"
          >
            <i className="ri-archive-drawer-line"></i>
            深挖档案
          </a>

          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className="ml-auto grid h-10 w-10 cursor-pointer place-items-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* mobile menu */}
        <div
          className={`overflow-hidden border-background-200 transition-all duration-300 lg:hidden ${
            open ? 'max-h-96 border-t' : 'max-h-0'
          }`}
        >
          <nav className="flex flex-col bg-background-50 px-4 py-3">
            {navLinks.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={(e) => {
                  e.preventDefault();
                  go(n.href);
                }}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-50"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#dive"
              onClick={(e) => {
                e.preventDefault();
                go('#dive');
              }}
              className="mt-2 cursor-pointer rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              进入深挖档案
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}